import { LS_EDIT_ABILITTY } from '@/constants';

import type { IUser } from '@/entities/user/model/types';

import { useUserApi } from '@/entities/user/api';

const ADMIN = 'admin';
const COPYWRITER = 'copywriter';

export const useUserStore = defineStore('user', () => {
  const api = useUserApi();
  const user = ref<IUser | null>(null);
  const wasFetching = ref(false);
  const companyStore = useCompanyStore();
  const { company } = storeToRefs(companyStore);

  const isAdmin = computed(
    () =>
      !!user.value?.roles.find(
        ({ login, role }) => company.value?.login === login && role === ADMIN,
      ),
  );

  const isCopywriter = computed(
    () =>
      !!user.value?.roles.find(
        ({ login, role }) => login === company.value?.login && [ADMIN, COPYWRITER].includes(role),
      ),
  );

  const isOwner = computed(
    () =>
      !!user.value?.roles.find(({ login, isOwner }) => login === company.value?.login && isOwner),
  );

  const isEditEnabled = ref(false);

  const setEditEnabled = (state: boolean) => {
    isEditEnabled.value = state;
  };

  const toggleEditEnable = () => {
    if (!user.value) {
      return;
    }

    isEditEnabled.value = !isEditEnabled.value;

    localStorage.setItem(LS_EDIT_ABILITTY, JSON.stringify(isEditEnabled.value));
  };

  const logout = async () => {
    await api.logout();

    user.value = null;

    // TODO: По нормальному обработать
    document.location.reload();
  };

  const fetch = async (): Promise<IUser | null> => {
    try {
      user.value = (await api.fetch()).data;
    } catch {
      user.value = null;
    }

    return user.value;
  };

  const sendCode = (phone: string, token: string | null) => {
    return api.sendCode(phone, token);
  };

  const validateCode = (phone: string, code: string): Promise<unknown> => {
    return api.validateCode(phone, code);
  };

  return {
    user,
    isAdmin,
    isCopywriter,
    isOwner,
    isEditEnabled,
    wasFetching,
    sendCode,
    validateCode,
    fetch,
    logout,
    toggleEditEnable,
    setEditEnabled,
  };
});
